const getters = {
    userType: state => state.userType,
    userCountry: state => state.userCountry
};

export default getters;